import { IArgumentType } from '../functions/utils';
import { InferenceError } from '../errors';
import { IFunctionToken } from '../typings/token';
import { TypeGenerator, isShallowEquals, isStringLike, isDigit, isNumber } from '../utils/type';


export function UNIQUE(args: IArgumentType[], token: IFunctionToken) {
  const functionName = token.formatName;

  if (args.length > 1) {
    if (args.find(arg => arg.isArray || !isSimpleType(arg.type))) {
      throw new InferenceError('function-argument-error', `${functionName} 函数的仅支持单个简单数组类型的参数或多个相同的简单类型的参数`, token.position);
    }
    if (!isShallowEquals(args, false)) {
      throw new InferenceError('function-argument-error', `${functionName} 函数的仅支持单个简单数组类型的参数或多个相同的简单类型的参数`, token.position);
    }

    // 数字类型，有Number类型则返回Number数组类型
    if (args.every(item => isDigit(item, false))) {
      const hasNumber = args.find(item => isNumber(item));
      return hasNumber ? TypeGenerator.NumberArray() : TypeGenerator.IntegerArray();
    }

    // 类字符串类型，如果存在多种类型则返回String类型，否则返回其中单个值的类型
    if (args.every(item => isStringLike(item, false))) {
      if (new Set(args.map(item => item.type)).size > 1) {
        return TypeGenerator.StringArray();
      } else {
        return TypeGenerator.ArrayOf(args[0].type);
      }
    }

  }

  const firstArgType = args[0];

  if (!firstArgType.isArray) {
    if (!isSimpleType(firstArgType.type)) {
      throw new InferenceError('function-argument-error', `${functionName} 函数的仅支持单个简单数组类型的参数或多个相同的简单类型的参数`, token.position);
    }
    return TypeGenerator.ArrayOf(firstArgType.type);
  }

  if (!isSimpleType(firstArgType.type) || (() => {
    return (firstArgType as any).values && ((firstArgType as any).values.find((item: any) => {
      return item.isArray;
    }));
  })()) {
    throw new InferenceError('function-argument-error', `${functionName} 函数的仅支持单个简单数组类型的参数或多个相同的简单类型的参数`, token.position);
  }


  return firstArgType;
}


function isSimpleType(type: string) {
  return [
    'Id', 'String', 'PhoneNr', 'Url', 'Email',
    'Integer', 'Number', 'Boolean', 'Enum',
    'DateTime', 'Date', 'Time'
  ].includes(type);
}
